export default __webpack_public_path__ + "static/media/699.7dd07b22.gif";